import React, { Component } from "react";
import { applyMiddleware, createStore } from "redux";
import reducers from "../store/reducer";
import Provider from "react-redux/lib/components/Provider";
import { updateMarket, initializeMap } from "../store/actionCreator";
import thunkMiddleware from "redux-thunk";
import Home from "./home";
import "../css/util.css";
// Google Analytics removed - ad-free version
import { isMobile } from "react-device-detect";

import {
    BrowserRouter,
    Switch,
    Route,
    Redirect,
    withRouter,
} from "react-router-dom";

const store = createStore(reducers, applyMiddleware(thunkMiddleware));

// Component to handle market updates based on route
class MarketRouteHandler extends Component {
    constructor(props) {
        super(props);
        this.hasInitialized = false;
        // Initialize market from route before first render
        this.updateMarketFromRoute(props.location.pathname, true);
    }

    componentDidMount() {
        store.dispatch(initializeMap());
        this.initAnalytics();
    }

    componentDidUpdate(prevProps) {
        // Update market when route changes
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.updateMarketFromRoute(this.props.location.pathname, false);
        }
    }

    updateMarketFromRoute(path, isInitialLoad = false) {
        // Don't update market if we're on a business detail page
        // The market should already be set from the previous route
        if (path.startsWith("/business/")) {
            return;
        }
        // Check if it's the new URL format: /{market}/{businessName}
        // We need to extract market from the path
        const newPathMatch = path.match(/^\/([^/]+)\/([^/]+)$/);
        if (newPathMatch && newPathMatch[1] !== "business") {
            // This is a business detail page in new format, extract market
            const marketFromPath = newPathMatch[1];
            // Validate it's a known market
            const knownMarkets = [
                "gta",
                "austin",
                "nyc",
                "chicago",
                "miami",
                "seattle",
                "sfbay",
                "losangeles",
                "portland",
                "lasvegas",
            ];
            if (knownMarkets.includes(marketFromPath)) {
                // Set the market but don't fetch data (we're on detail page)
                const currentState = store.getState();
                if (currentState.filters.market !== marketFromPath) {
                    store.dispatch(updateMarket(marketFromPath));
                }
                return;
            }
        }

        let market = "gta"; // default

        if (path === "/gta" || path === "/gta/") {
            market = "gta";
        } else if (path === "/austin" || path === "/austin/") {
            market = "austin";
        } else if (path === "/nyc" || path === "/nyc/") {
            market = "nyc";
        } else if (path === "/chicago" || path === "/chicago/") {
            market = "chicago";
        } else if (path === "/miami" || path === "/miami/") {
            market = "miami";
        } else if (path === "/seattle" || path === "/seattle/") {
            market = "seattle";
        } else if (path === "/sfbay" || path === "/sfbay/") {
            market = "sfbay";
        } else if (path === "/losangeles" || path === "/losangeles/") {
            market = "losangeles";
        } else if (path === "/portland" || path === "/portland/") {
            market = "portland";
        } else if (path === "/lasvegas" || path === "/lasvegas/") {
            market = "lasvegas";
        }

        // On initial load, always call the API to fetch data
        // Otherwise, only update market if it has actually changed to avoid unnecessary API calls
        const currentState = store.getState();
        const currentMarket = currentState.filters.market;
        const hasBusinessData =
            currentState.business && currentState.business.length > 0;

        if (isInitialLoad || currentMarket !== market || !hasBusinessData) {
            store.dispatch(updateMarket(market));
            this.hasInitialized = true;
        }
    }

    initAnalytics() {
        // Google Analytics removed - ad-free version
        // ReactGA.initialize("UA-151890897-1");
        // ReactGA.set({ isMobile: isMobile });
    }

    render() {
        return <Home />;
    }
}

const MarketRouteHandlerWithRouter = withRouter(MarketRouteHandler);

class Main extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => <Redirect to="/gta" />}
                        />
                        <Route
                            path="/business/:businessPath"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/gta"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/austin"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/nyc"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/chicago"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/miami"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/seattle"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/sfbay"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/losangeles"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/portland"
                            component={MarketRouteHandlerWithRouter}
                        />
                        <Route
                            path="/lasvegas"
                            component={MarketRouteHandlerWithRouter}
                        />
                    </Switch>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default Main;
